import { styled } from '@mui/material';
import Background from '@assets/backgrounds/questionnaire-intro-background.png';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  textAlign: 'center',
  gap: theme.spacing(13),
  borderTop: `${theme.spacing(5)} solid ${theme.palette.primary.main}`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right',
  backgroundImage: `url(${Background})`,
}));
